import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Lb4ApiService } from 'src/app/shared/service/api/lb4-api.service';

@Injectable({
  providedIn: 'root'
})
export class DetailApplicationService {
  // 修改的工程分类
  public civilOrElec: Subject<any> = new Subject<any>();

  // 修改的派单厂务工程师联系方式
  public sendAssignPhoneData: Subject<string> = new Subject<string>();

  // 预算编码
  public budgetCode: Subject<string> = new Subject<string>();
  // 挂账部门
  public creditDepartment: Subject<string> = new Subject<string>();

  constructor(
    private lb4ApiService: Lb4ApiService,
  ) { }

  // 查询step5的签核数据和签核状态
  async getSignStep5Arr(formid: string) {
    let signStep5Arr = [];
    let signDataArr = [];
    await this.lb4ApiService.find('form_sign_process', {
      fields: { civilOrElectro: true, status: true },
      where: { formId: formid, signStep: 5 },
    }).then(signData => {
      signDataArr = signData;
      for (let each in signData) {
        signStep5Arr.push(signData[each]['status']);
      }
    });
    return { signStep5Arr, signDataArr };
  }

  // 查询当前单据的最大版本下的签核步骤流程
  async getMaxVersionInitSignOrder(formid: string, maxVersionNum: number, civilEngineering: boolean, electromechanical: boolean) {
    let eleSignData = [];
    let civilSignData = [];
    const signData = await this.lb4ApiService.find('form_sign_process', {
      where: { formId: formid, version: maxVersionNum }
    });
    if (civilEngineering) {
      // 获取土建的签核记录:去掉签核第5步骤的机电(civilOrElectro=1)的厂商标单制定
      civilSignData = signData.filter(value => (value['civilOrElectro'] !== 1));
    }
    if (electromechanical) {
      // 获取机电的签核记录:去掉签核第5步骤的土建(civilOrElectro=0)的厂商标单制定
      eleSignData = signData.filter(value => (value['civilOrElectro'] !== 0));
    }
    return { "civilSignData": civilSignData, "eleSignData": eleSignData };
  }
}
